import { BaseModel } from '../common/models/base';

export const apiJson = async<R, B extends any>(url: string, method: 'get' | 'post' | 'put' | 'delete', data?: B, options?: RequestInit & { silently?: boolean; }) => {
    return new Promise<R>(async (resolve, reject) => {
        const strignifiedData: string | undefined = data ? JSON.stringify(data) : undefined;
        const reqParams = strignifiedData ? {
            method,
            body: strignifiedData,
            ...options,
            headers: {
                ...options?.headers ?? {},
                'Content-Type': 'application/json',
                'frontend': '1'
            },
        } : {
            method,
            ...options,
            headers: {
                ...options?.headers ?? {},
                'frontend': '1'
            },
        };
        if (options?.silently) {
            // @ts-ignore 
            reqParams.headers['silently'] = '1';
        }
        try {
            fetch(url, reqParams).then(async (result) => {
                if (result.status >= 200 && result.status < 300) {
                    resolve(await result.json());
                } else {
                    reject(result.status);
                }
            }).catch(err => {
                // network error !
                console.log('err in json', err);
                console.log('navigator.onLine', navigator.onLine);
                reject(err);
            });
        } catch (error) {
            console.log('error');
            console.log('navigator.onLine', navigator.onLine);
        }

    });

};

export const postData = <T extends BaseModel>(type: string, data: Partial<T>, silently?: boolean): Promise<DataPostResponse<T>> => {
    return apiJson<DataPostResponse<T>, Partial<T>>('/data/' + type, 'post', data, { silently });
};

export const deleteData = (type: string, id: ModelId): Promise<boolean> => {
    return apiJson<boolean, any>('/data/' + type + '/' + id, 'delete');
};
